import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { Transform } from 'class-transformer';
import { stringToBooleanNullable } from '../../types-transformers/boolean-transformers';

export class CheckInEventUsersFilter implements PaginationFilter {
	@Transform(stringToBooleanNullable)
	isTicketUsed?: boolean;

	search?: string;

	pageSize?: number | null;
	page?: number | null;
}
